// ======================================================================
// File Name       : EnterpriseNotificationSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { onChangeWrapper } from '../../utils/FormUtils';
import { VALIDATE_TYPE, WRITE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import PaginationCustom from '../Pagination';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomButton from '../button/CustomButton';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import * as Path from '../../constants/PathConstants';

class EnterpriseNotificationSearch extends React.Component {
  render() {
    const {
      noticeForEnterpriseSecernIds,
      noticeTitle,
      releaseTargetForEnterprise,
      publicStatus,
      publicDateFrom,
      publicDateTo,
      noticeSortType,
      onInputChange,
      onSearchBtnClick,
      openExportDialog,
      readOnlyFlag,
      canEditNoticeForEnterprise
    } = this.props;
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="margin-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
              タイトル
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="noticeTitle" label="コンテンツ名" value={noticeTitle} />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
              公開範囲
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="releaseTargetForEnterprise"
                  label="ステータス"
                  value={releaseTargetForEnterprise}
                  data={SELECT_BOX_DATA.RELEASE_TARGET_FOR_ENTERPRISE}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
              公開ステータス
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="publicStatus"
                  label="ステータス"
                  value={publicStatus}
                  data={SELECT_BOX_DATA.PUBLIC_STATUS_ENTERPRISE_NOTIFICATION}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
              公開期間
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="publicDateFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                  value="publicDateFrom"
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="publicDateTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                  value="publicDateTo"
                />
              </Col>
            </Form.Group>
            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom={'publicDateFrom'}
                keyDateTo={'publicDateTo'}
              />
            </Col>
          </Col>
          <Col sm={12} className="text-center">
            <CustomButton
              btnStyle="btn btn-primary btn-96 margin-top-10"
              text="検索"
              type="submit"
              iconClass="bi bi-search"
            />
          </Col>
          <Form.Group>
            <Col sm={12} className="margin-top-10 margin-bottom-15 padding-left-right-clear">
              <Col sm={9} className="inline-flex">
                {!readOnlyFlag && canEditNoticeForEnterprise && (
                  <>
                    <CustomLink
                      className="margin-right-7 btn-register margin-right-10"
                      to={Path.ENTERPRISE_NOTIFICATION_REGISTER}
                      text="お知らせ情報の新規登録"
                      icon={ICON.REGIST}
                    />
                    <CustomLink
                      className="margin-right-7 btn-csv-import"
                      to={Path.ENTERPRISE_NOTIFICATION_IMPORT}
                      text="CSV一括投入"
                      icon={ICON.IMPORT}
                    />
                  </>
                )}
              </Col>
              <Col sm={3}>
                <CustomButton
                  btnStyle="btn btn-export-csv float-end"
                  handleClick={openExportDialog}
                  text="一括出力"
                  iconClass="bi bi-download"
                />
              </Col>
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default EnterpriseNotificationSearch;
